import type {OrganizationPermissionRole, Team} from 'orgs/OrganizationConstants';

export const ORGANIZATION_MEMBER_EVENT_PAYLOADS = {
  TEAM_UPDATE: {} as {entityId?: string},
  TEAM_UPDATE_COMPLETED: {} as {team: Team},
  TEAM_UPDATE_FAILED: {} as {entityId?: string},

  MEMBER_PERMISSION_UPDATE: {} as {userId: string},
  MEMBER_PERMISSION_UPDATE_COMPLETED: {} as {
    entityId: string;
    userId: string;
    role: OrganizationPermissionRole;
  },
  MEMBER_PERMISSION_UPDATE_FAILED: {} as {userId: string},

  MEMBER_REMOVAL: {} as {userId: string},
  MEMBER_REMOVAL_COMPLETED: {} as {entityId: string; userId: string},
  MEMBER_REMOVAL_FAILED: {} as {userId: string},
} as const;

export type OrganizationMemberEventPayload = typeof ORGANIZATION_MEMBER_EVENT_PAYLOADS;
